export default __webpack_public_path__ + "tieoutLogo.41001bca.png";